import { render, staticRenderFns } from "./beveledge.vue?vue&type=template&id=d33f6b9c"
import script from "./beveledge.vue?vue&type=script&lang=js"
export * from "./beveledge.vue?vue&type=script&lang=js"
import style0 from "./beveledge.vue?vue&type=style&index=0&id=d33f6b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports